// QAT's host, as deploy/envs/qat/values.yaml and signIn.ts name it.
const BRONZE_HOST = "bronze.centrobenefits.io";

/** The name the app goes by on a host: Bronze in QAT, Golden in preprod and a local dev server. */
export const tierFor = (hostname: string): string =>
  hostname === BRONZE_HOST ? "Bronze" : "Golden";

export const TIER = tierFor(window.location.hostname);

/** The tier's name within a sentence: "the bronze set". */
export const TIER_IN_TEXT = TIER.toLowerCase();
